import {EventVerteiler} from "../../global/eventVerteiler";
import {IOwayoDataModel} from "../model";
import globalsObject, {translate} from "../globalsObject";
import {EntwurfListenEintragFromBackend} from "../databaseInterfaceClasses";
import {arrayElementByKeyValue, arrayIndexByKeyValue} from "../../global/arrayHelper";

export class EntwuerfeVerwalter {
    private model: IOwayoDataModel;
    public constructor(model: IOwayoDataModel){
        this.model = model;
    }

    private static handleError(severity, happenedHere, messageToDisplay, callbackAfterMessageClosed?) {
        const error = {
            severity: severity,
            happenedHere: happenedHere,
            messageToDisplay: messageToDisplay,
            callbackAfterMessageClosed:callbackAfterMessageClosed
        };
        EventVerteiler.broadcast("ErrorHappendedEvent", error);
    }

    updateEntwurfName(saveID:number, newName:string) {
        const $this = this;
        $.post(
            "/konfigurator_php/actionmodul/updateEntwurfName.php",
            {saveID: saveID, newName: newName.substring(0, 39)},
            function (data) {
                if (data.success === true) {
                    const entwurf = arrayElementByKeyValue($this.model.user.getEntwuerfe(), "SaveID", saveID);
                    if (entwurf !== null) {
                        entwurf.Name = newName;
                    }
                    EventVerteiler.broadcast("entwurfNameChangedEvent", {saveID: saveID, newName: newName});
                } else {
                    EventVerteiler.broadcast("entwurfNameChangeFailedEvent", {saveID: saveID, newName: newName});
                }
            },
            "json"
        );
    }

    private getDeletedDraftsFromPHPResponse(draftsFromDB) {
        const deletedDrafts = [] as any[];
        const anzEntwuerfe = this.model.user.getEntwuerfe().length;
        for (let i = 0; i < anzEntwuerfe; i++) {
            if (arrayIndexByKeyValue(draftsFromDB, "SaveID", this.model.user.getEntwuerfe()[i].SaveID) === -1) {
                deletedDrafts.push(this.model.user.getEntwuerfe()[i]);
            }
        }
        return deletedDrafts;
    }

    private removeDrafts(deletedDrafts) {
        let i;
        const anzDeletedDrafts = deletedDrafts.length;
        if (anzDeletedDrafts > 0) {
            for (i = 0; i < anzDeletedDrafts; i++) {
                this.model.user.getEntwuerfe().splice(arrayIndexByKeyValue(this.model.user.getEntwuerfe(), "SaveID", deletedDrafts[i].SaveID), 1);
            }
            EventVerteiler.broadcast("draftsRemotelyDeletedEvent", {drafts: deletedDrafts});
        }
    }

    private initEntwuerfe() {
        this.loadEntwuerfeFromDB().then((data:{derivedUserDataPath:string, drafts:EntwurfListenEintragFromBackend[]})=>{
            this.model.user.setDerivedUserDataPath(data.derivedUserDataPath);
            this.model.user.setEntwuerfe(data.drafts);
            if (data.drafts.length === 0) {
                EventVerteiler.broadcast("displayHintEvent","konf_noDraftsSavedYet");
                return;
            }
            EventVerteiler.broadcast("initDraftsEvent", {drafts:this.model.user.getEntwuerfe()})
            EventVerteiler.broadcast("openEntwuerfeFensterEvent")


        }).catch(()=>EntwuerfeVerwalter.errorLoadingEntwuerfe())
    }
    private static errorLoadingEntwuerfe() {
        EntwuerfeVerwalter.handleError(
            "ajaxFail",
            "checkIfDraftsAreUpToDate",
            translate(
                "konf_error_loadingDrafts",
                "Verzeihung, ein Fehler ist aufgetreten und Ihre Entwürfe konnten nicht geladen werden"
            )
        );
    }

    public checkIfDraftsAreUpToDate() {
        const $this = this;
        if (this.model.user.isLoggedIn() === false) {
            EventVerteiler.broadcast("displayNotLoggedInWarningEvent", "warningNotLoggedIn");
        }
        if(this.model.user.getEntwuerfe().length === 0) {
            this.initEntwuerfe();
            return;
        }

        function checkThem(draftsFromDB) {
            if (draftsFromDB.length === 0) {
                EventVerteiler.broadcast("displayHintEvent","konf_noDraftsSavedYet");
            }

            const newDrafts = $this.getNewDraftsFromPHPResponse(draftsFromDB);
            const deletedDrafts = $this.getDeletedDraftsFromPHPResponse(draftsFromDB);

            $this.removeDrafts(deletedDrafts);

            if (newDrafts.length > 0) {
                $this.model.user.setEntwuerfe(newDrafts.concat($this.model.user.getEntwuerfe()));
                EventVerteiler.broadcast("draftRemotelyAddedEvent", {drafts: newDrafts});
                if ($this.model.user.getEntwuerfe().length === 1 ) {
                    EventVerteiler.broadcast("openEntwuerfeEvent");
                }
            }
            if($this.model.user.getEntwuerfe().length > 0) {
                EventVerteiler.broadcast("openEntwuerfeFensterEvent");
            }
        }
        this.loadEntwuerfeFromDB().then((data:{derivedUserDataPath:string, drafts:EntwurfListenEintragFromBackend[]})=>{
            $this.model.user.setDerivedUserDataPath(data.derivedUserDataPath);
            checkThem(data.drafts);
        }).catch(()=>EntwuerfeVerwalter.errorLoadingEntwuerfe());
    }

    private loadEntwuerfeFromDB() {
        return new Promise((resolve:(data)=>void, reject)=>{
        $.ajax(
            {
                url:"/konfigurator_php/actionmodul/loadEntwuerfe.php",
                    data: {iso:this.model.getSprache()},
                type : "GET",
                dataType : "json"
            }
                )
                .done(data=>resolve(data))
                .fail(()=>reject());
        })
    }

    private getNewDraftsFromPHPResponse(draftsFromDB) {
        const newDrafts = [] as any[];

        for (let i = 0, lenI = draftsFromDB.length; i < lenI; i++) {
            if (arrayIndexByKeyValue(this.model.user.getEntwuerfe(), "SaveID", draftsFromDB[i].SaveID) === -1) {
                newDrafts.push(draftsFromDB[i]);
            }
        }
        return newDrafts;
    }

    public getAnzEntwuerfe = ()=>this.model.user.getEntwuerfe().length;
    public getCurrentEntwurfID = ()=> this.model.entwurf.getID();
    public getEntwurfBySaveID = (saveID:number)=>arrayElementByKeyValue(this.model.user.getEntwuerfe(), "SaveID", saveID);

    public static entwurfIsMissingPreviewPic = function() {
        globalsObject.resourceManager.createTask("pleasetakePictures")
            .discardAfterExecution()
            .when("designtexturesLoaded", "done")
            .thenDo(
                ()=>setTimeout(
                    ()=>{
                        EventVerteiler.broadcast("pleaseTakePicturesEventAndReturnThemToMe", (screenshots) => {
                            globalsObject.controller.saveEntwurfPreviewPics(screenshots, null);
                        })
                    }, 2000));
    };

    public getEntwuerfe = ()=>this.model.user.getEntwuerfe();

    public getEntwurfName(saveID:number) {
        const entwurfInfo = arrayElementByKeyValue(this.model.user.getEntwuerfe(), "SaveID", saveID);
        if (entwurfInfo !== null) {
            return entwurfInfo.Name;
        }
        return "";
    }

    public draftPreviewRequested() {
        EventVerteiler.broadcast("draftpreviewPicRequestedEvent");
    }
}
